/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceFaqItem } from './SurfaceFaqItem';
import {
    SurfaceFaqItemFromJSON,
    SurfaceFaqItemFromJSONTyped,
    SurfaceFaqItemToJSON,
    SurfaceFaqItemToJSONTyped,
} from './SurfaceFaqItem';

/**
 * 
 * @export
 * @interface SurfaceFaqConfig
 */
export interface SurfaceFaqConfig {
    /**
     * 
     * @type {Array<SurfaceFaqItem>}
     * @memberof SurfaceFaqConfig
     */
    items?: Array<SurfaceFaqItem>;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceFaqConfig
     */
    allowMultipleOpen?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceFaqConfig
     */
    searchable?: boolean;
}

/**
 * Check if a given object implements the SurfaceFaqConfig interface.
 */
export function instanceOfSurfaceFaqConfig(value: object): value is SurfaceFaqConfig {
    return true;
}

export function SurfaceFaqConfigFromJSON(json: any): SurfaceFaqConfig {
    return SurfaceFaqConfigFromJSONTyped(json, false);
}

export function SurfaceFaqConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceFaqConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(SurfaceFaqItemFromJSON)),
        'allowMultipleOpen': json['allowMultipleOpen'] == null ? undefined : json['allowMultipleOpen'],
        'searchable': json['searchable'] == null ? undefined : json['searchable'],
    };
}

export function SurfaceFaqConfigToJSON(json: any): SurfaceFaqConfig {
    return SurfaceFaqConfigToJSONTyped(json, false);
}

export function SurfaceFaqConfigToJSONTyped(value?: SurfaceFaqConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(SurfaceFaqItemToJSON)),
        'allowMultipleOpen': value['allowMultipleOpen'],
        'searchable': value['searchable'],
    };
}

